import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoPmEvents = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 61,
	height: 100,
	viewBox: "0 0 61 100",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1.20972 4.02032C1.20972 2.22165 2.68136 0.75 4.47868 0.75H56.8039C58.6012 0.75 60.0728 2.22165 60.0728 4.02032V8.68053C60.0728 10.3975 58.6012 11.8691 56.8039 11.8691H54.7599V25.5227C54.7599 33.1262 51.2443 39.9939 45.7652 44.4906C44.5401 45.5534 43.7212 46.371 43.232 47.1068C42.7415 47.9244 42.4962 48.6602 42.4962 49.8049C42.4962 50.9495 42.7415 51.6853 43.232 52.5029C43.7212 53.2373 44.5401 54.0563 45.7652 55.1191C51.2443 59.6158 54.7599 66.4835 54.7599 74.087V87.7406H56.8039C58.6012 87.7406 60.0728 89.2123 60.0728 90.9292V95.5894C60.0728 97.3881 58.6012 98.8597 56.8039 98.8597H4.47868C2.68136 98.8597 1.20972 97.3881 1.20972 95.5894V90.9292C1.20972 89.2123 2.68136 87.7406 4.47868 87.7406H6.52263V74.087C6.52263 66.4835 10.0382 59.6158 15.516 55.1191C16.7424 54.0563 17.56 53.2387 18.0505 52.5029C18.5411 51.6853 18.7863 50.9495 18.7863 49.8049C18.7863 48.6602 18.5411 47.9244 18.0505 47.1068C17.5613 46.371 16.7424 45.5534 15.5174 44.4906C10.0382 39.9939 6.52263 33.1262 6.52263 25.5227V11.8691H4.47868C2.68136 11.8691 1.20972 10.3975 1.20972 8.68053V4.02032Z",
			stroke: "#172B4D",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.0649 82.4262C14.3731 74.4126 21.8934 68.6091 30.6416 68.5273C39.3897 68.6091 46.91 74.4139 48.2195 82.4262C48.3013 83.0803 47.8108 83.7343 47.0749 83.7343H14.2095C13.4737 83.7343 12.9818 83.0789 13.0649 82.4262Z",
			fill: "#0517F8",
			stroke: "#172B4D",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.5365 43.5711C37.0234 46.7215 34.0736 49.003 30.6422 49.0352C27.2109 49.003 24.2611 46.721 23.7475 43.5711C23.7154 43.314 23.9078 43.0569 24.1964 43.0569H37.0875C37.3761 43.0569 37.5691 43.3145 37.5365 43.5711Z",
			fill: "#0517F8",
			stroke: "#172B4D",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .750122,
			y: .75,
			width: 59.323,
			height: 11.0368,
			rx: 4.36364,
			fill: "#CDD1FE",
			stroke: "#172B4D",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .75,
			y: 87.6641,
			width: 59.323,
			height: 11.0368,
			rx: 4.36364,
			fill: "#CDD1FE",
			stroke: "#172B4D",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M1.20972 3.04987L3.50906 0.980469H17.535C17.535 0.980469 17.5113 7.56708 17.535 11.7874C17.5895 21.4867 14.1627 32.5581 17.9949 36.6202C21.8271 40.6824 28.02 50.5083 22.1337 57.3143C16.2474 64.1203 16.1554 80.5376 16.8452 87.8955C17.535 95.2534 16.8452 98.9324 16.8452 98.9324H3.96892L1.43965 97.0929C1.20972 94.7935 1.11774 89.873 2.58932 88.5853C4.0609 87.2977 5.96169 87.5889 6.72813 87.8955V73.8696L7.8778 66.7416L12.0166 58.9238L17.9949 53.4054L19.1446 49.4965L16.8452 45.3577L9.71727 37.54L6.72813 29.2624V12.0173L2.35939 11.3275L1.20972 8.79822V3.04987Z",
			fill: "#0517F8"
		})
	]
});
export default SvgNoPmEvents;
